import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

export interface AuthState {
  token: string;
}

export const AuthAdapter = createEntityAdapter<AuthState>();

const initialState: AuthState = { token: '' };

const authSlice = createSlice({
  name: 'auth',
  initialState: AuthAdapter.getInitialState(initialState),
  reducers: {
    setToken: (state, action) => {
      return { ...state, token: action.payload.token };
    },
  },
});

export const { setToken } = authSlice.actions;
export default authSlice.reducer;
